<template>
  <div id="app">
    <background loader @loaded="onBackgroundLoaded"></background>
    <about-us v-if="actionAbountUs" ref="about_us" @mounted="onMounted" @closed="onClosed"></about-us>
    <services v-if="actionServices" ref="services" @mounted="onMounted" @closed="onClosed"></services>
    <solution v-if="actionSolution" ref="solution" @mounted="onMounted" @closed="onClosed"></solution>
    <contact-us v-if="actionContactUs" ref="contact_us" @mounted="onMounted" @closed="onClosed"></contact-us>
    <paginator ref="paginator" @change-page="scrollPage"></paginator>
    <navigator v-if="loaded" @menu-action=action></navigator>
  </div>
</template>

<script>
import { PaginatorMixin } from '@/mixins/paginator.mixin'

import Background from "@/components/Background.vue"
import AboutUs from "@/components/AboutUs.vue"
import Services from "@/components/Services.vue"
import Solution from "@/components/Solution.vue"
import ContactUs from "@/components/ContactUs.vue"
import Paginator from '@/components/Paginator.vue'
import Navigator from "@/components/Navigator.vue"

export default {
  name: 'App',
  mixins: [
    PaginatorMixin
  ],
  components: {
    Background,
    AboutUs,
    Services,
    Solution,
    ContactUs,
    Paginator,
    Navigator
  },
  data: () => ({
    actioninfo: {
      about_us: { label: 'About Us', width: 0, x: 0, height: 0, y: 0, layer: 'about_us_layer' },
      services: { label: 'Services', width: 0, x: 0, height: 0, y: 0, layer: 'services_layer' },
      solution: { label: 'Solution', width: 0, x: 0, height: 0, y: 0, layer: 'solution_layer' },
      contact_us: { label: 'Contact Us', width: 0, x: 0, height: 0, y: 0, layer: 'contact_us_layer' },
    },
    request: {
      id: 'about_us',
      previd: '',
    },
    loaded: false,
  }),
  computed: {
    actionAbountUs() { return this.loaded && (this.request.id == 'about_us' || this.request.previd == 'about_us') },
    actionServices() { return this.loaded && (this.request.id == 'services' || this.request.previd == 'services') },
    actionSolution() { return this.loaded && (this.request.id == 'solution' || this.request.previd == 'solution') },
    actionContactUs() { return this.loaded && (this.request.id == 'contact_us' || this.request.previd == 'contact_us') },
  },
  created() {
    let arg__ = navigator.userAgent||navigator.vendor||window.opera
    window.mobile = (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(arg__) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(arg__.substr(0,4))
    )
    window.iOS = (
      [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod'
      ].includes(navigator.platform)
      // iPad on iOS 13 detection
      || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    )
    window.safari = /^((?!chrome|android).)*safari/i.test(arg__)

    // // Opera 8.0+
    // var isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;

    // // Firefox 1.0+
    // var isFirefox = typeof InstallTrigger !== 'undefined';

    // // Safari 3.0+ "[object HTMLElementConstructor]" 
    // var isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && window['safari'].pushNotification));

    // // Internet Explorer 6-11
    // var isIE = /*@cc_on!@*/false || !!document.documentMode;

    // // Edge 20+
    // var isEdge = !isIE && !!window.StyleMedia;

    // // Chrome 1 - 79
    // var isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);

    // // Edge (based on chromium) detection
    // var isEdgeChromium = isChrome && (navigator.userAgent.indexOf("Edg") != -1);

    // // Blink engine detection
    // var isBlink = (isChrome || isOpera) && !!window.CSS;
  },
  methods: {
    onBackgroundLoaded() {
      this.loaded = true
    },
    onMounted(id) {
      this.setEnv()
      this.$refs[id].open()

      if(this.actioninfo[this.request.previd]) document.querySelector(`.${this.actioninfo[this.request.previd].layer}`).style.zIndex = 1
      if(this.actioninfo[this.request.id]) document.querySelector(`.${this.actioninfo[this.request.id].layer}`).style.zIndex = 2

      if(['services'].includes(id)) {
        setTimeout(() => { this.checkpagenv() }, 1000);
      }
    },
    onClosed(v) {
      this.request.previd = ''
      this.autoScrolling = false
    },
    action(id) {
      if(this.request.id == id) return
      
      this.request.previd = this.request.id
      this.request.id = id

      this.autoScrolling = true
      this.$refs[this.request.previd].close()
      this.currentPageLayer = this.actioninfo[this.request.id].layer
    }
  }
}
</script>

<style lang="scss">
#app {
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  color: #fff;
}

.dark_sky__ {
  color: rgb(9, 49, 66);
}
.dark_red__ {
  color: rgb(100, 26, 61);
}

.effect_line {
  position: relative;
  padding-right: 3rem;

  .line {
    position: absolute;
    top: 0; 
    left: 0;

    height: 100%;
    width: 3px;
    background-color: #fff;
    transform-origin: 0 50%;
  }
}

.text_line_end {
  padding-right: 3rem;
  border-right: solid 3px #fff;
}

div[class^='page_'], 
div[class*='page_'] {
  display: flex;
  justify-content: center;
  align-items: center;

  width: 100%;
  height: 100%;

  .contents_wrapper {
    display: flex;
    justify-content: center;
    padding: 9rem;

    .limited_width_box {
      display: flex;
      flex-direction: column;
      // max-width: 130rem;

      .title {
        span {
          display: inline-block;

          &.marker {
            font-size: 3rem;
          }
          &.nowrap {
            white-space: nowrap;
          }
        }

        &.main {
          display: flex;
          flex-wrap: wrap;
          margin: -.75rem;

          font-size: 7rem;
          font-weight: 900;
          line-height: 9rem;

          .text {
            margin: .75rem;
          }
        }

        &.sub {
          text-align: center;
          font-size: 4rem;
        }
      }
      .description {
        &.main {
          font-size: 3rem;
          margin-top: 4rem;
        }
        &.margin_5 {
          margin-top: 7rem;
        }
      }

      .section_wrapper {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;

        margin: -2.5rem;
        padding-top: 5rem;
        
        &.balanced >* {
          flex: 1 1 43rem;
        }

        .section {
          margin: 2.5rem;
          
          .title {
            font-size: 4rem;
            font-weight: 700;
            line-height: 6.5rem;

            &.gap {
              display: flex;
              flex-wrap: wrap;
              margin: -.75rem;

              span {
                margin: .75rem;
                line-height: 4rem;
              }
              ul {
                margin-left: 3rem;
                opacity: .4;
              }
            }
          }

          .description{
            font-size: 1.5rem;
            margin-top: 2rem;

            ul {
              margin-left: 2rem;
            }
          }

          // .section_content {
          //   display: flex;
          //   gap: 5rem;
          // }

          // .features {
          //   font-size: 20px;
          //   padding-left: 1.5rem;
          // }
        }
      }
    }
  }
  .v-btn__content {
    color: rgb(9, 49, 66);
    font-size: 3rem;
  }
}
</style>
